/* CERA — cart drawer behaviour.
   Open/close/refresh and add-to-cart live in cera.js; this file adds the
   drawer's own interactions: quantity steppers, remove, the reward gifts,
   the discount code field and the upsell carousel.

   Gifts are real cart lines, not decoration. Each is tagged with the line
   item property _cera_gift so the section can render it as a reward row and
   so we can find it again to take it back out. */
(function () {
  'use strict';

  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var busy = false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function refresh() {
    if (window.CeraCart && window.CeraCart.refresh) return window.CeraCart.refresh();
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var host = $('[data-cera-cart]');
        if (!host || !data['cart-drawer']) return;
        var open = host.classList.contains('on');
        var holder = document.createElement('div');
        holder.innerHTML = data['cart-drawer'];
        var fresh = $('[data-cera-cart]', holder);
        if (fresh && host.parentNode) {
          host.parentNode.replaceChild(fresh, host);
          if (open) fresh.classList.add('on');
        }
      });
  }

  /* ---------- Rewards ---------- */

  function rewardData() {
    var el = $('[data-cera-rewards]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (err) { return []; }
  }

  /* Total of everything the customer actually chose. Gift lines are excluded
     so a gift can never pay for the next gift. */
  function earnedTotal(cart) {
    return cart.items.reduce(function (sum, item) {
      if (item.properties && item.properties._cera_gift) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function giftLine(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === variantId && it.properties && it.properties._cera_gift) return i + 1;
    }
    return 0;
  }

  /* Bring the gift lines in line with what the cart has earned. Runs after
     every change, and resolves once the cart is settled. */
  function syncGifts() {
    var rewards = rewardData();
    if (!rewards.length) return Promise.resolve(false);

    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = earnedTotal(cart);

        for (var i = 0; i < rewards.length; i++) {
          var rw = rewards[i];
          if (!rw.id) continue;
          var line = giftLine(cart, rw.id);

          if (total >= rw.at && !line) {
            var body = { id: rw.id, quantity: 1, properties: { _cera_gift: 'yes' } };
            if (rw.was) body.properties._cera_gift_was = rw.was;
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body)
            }).then(syncGifts).then(function () { return true; });
          }

          if (total < rw.at && line) {
            return changeLine(line, 0).then(syncGifts).then(function () { return true; });
          }
        }
        return false;
      })
      .catch(function () { return false; });
  }

  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  /* ---------- Interactions ---------- */

  document.addEventListener('click', function (e) {
    var drawer = e.target.closest('[data-cera-cart]');
    if (!drawer || busy) return;

    var step = e.target.closest('[data-cera-qty]');
    var kill = e.target.closest('[data-cera-remove]');
    var pay = e.target.closest('[data-cera-checkout]');

    if (step) {
      e.preventDefault();
      var row = step.closest('.ln');
      var shown = row ? $('.stp span', row) : null;
      var now = shown ? parseInt(shown.textContent, 10) : 1;
      var next = now + parseInt(step.dataset.ceraQty, 10);
      busy = true;
      changeLine(parseInt(step.dataset.line, 10), Math.max(0, next))
        .then(refresh)
        .then(function () { busy = false; });
      return;
    }

    if (kill) {
      e.preventDefault();
      busy = true;
      changeLine(parseInt(kill.dataset.line, 10), 0)
        .then(refresh)
        .then(function () { busy = false; });
      return;
    }

    if (pay) {
      e.preventDefault();
      window.location.href = root + 'checkout';
    }
  });

  /* ---------- Discount code ----------
     Shopify's AJAX cart API cannot apply a discount. Hitting /discount/CODE
     stores it on the session, and checkout picks it up from there. The amount
     is only known once checkout has run, so the drawer confirms the code
     rather than claiming a figure it cannot compute. */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cera-code-form]');
    if (!form) return;
    e.preventDefault();

    var input = $('[data-cera-code-input]', form.parentNode) || $('[data-cera-code-input]', form);
    var msg = $('[data-cera-code-msg]', form.parentNode);
    var code = input ? input.value.trim() : '';

    function say(text, ok) {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle('ok', !!ok);
      msg.hidden = false;
    }

    if (!code) { say(form.dataset.emptyMsg || 'Enter a code.', false); return; }

    fetch(root + 'discount/' + encodeURIComponent(code), { method: 'GET', cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('rejected');
        say(code.toUpperCase() + ' — applied at checkout.', true);
      })
      .catch(function () {
        say('"' + code.toUpperCase() + '" could not be applied. Check the spelling and try again.', false);
      });
  });

  /* ---------- Upsell carousel ---------- */

  function wireUpsell() {
    var track = $('[data-cera-up-track]');
    if (!track) return;
    var prev = $('[data-cera-up-prev]');
    var next = $('[data-cera-up-next]');
    if (!prev || !next) return;

    function update() {
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 4;
    }
    prev.onclick = function () { track.scrollBy({ left: -160 }); };
    next.onclick = function () { track.scrollBy({ left: 160 }); };
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* The section is replaced wholesale on every refresh, so rewire on mutation
     rather than once at load. */
  var observer = new MutationObserver(function () { wireUpsell(); });

  function start() {
    wireUpsell();
    observer.observe(document.body, { childList: true, subtree: true });
    // Catch a cart that drifted out of step between visits — a gift whose
    // threshold no longer holds, or one that was never added.
    syncGifts().then(function (changed) { if (changed) refresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // cera.js calls syncGifts before every repaint, so every other path in and
  // out of the cart settles the gifts without this file listening for it.
  window.CeraDrawer = { syncGifts: syncGifts, refresh: refresh };
})();
